import { render } from "./EntranceExitCreate.vue?vue&type=template&id=795cc3d0"
import script from "./EntranceExitCreate.vue?vue&type=script&lang=js"
export * from "./EntranceExitCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__